export default __webpack_public_path__ + "static/media/mobileBG.4d65a987.svg";